// extracted by mini-css-extract-plugin
export default {"numberOutput":"styles_number-output_Z4sRC"};